import { css } from 'styled-components';

const breakpoints = {
    tweak1600up: {
        type: 'tweakpoint',
        query: '(min-width: 1600px)',
        min: 1600,
        max: 0,
        dpi: 1,
        fontSize: 22,
    },
    wideScreenUpEnd: {
        type: 'breakpoint',
        query: '(min-width: 1200px)',
        min: 1201,
        max: 0,
        dpi: 1,
        fontSize: 22,
    },
    wideScreenUp: {
        type: 'breakpoint',
        query: '(max-width: 1599px)',
        min: 1201,
        max: 1600,
        dpi: 1,
        fontSize: 22,
    },
    largePortraitUp: {
        type: 'breakpoint',
        query: '(max-width: 1200px)',
        min: 1024,
        max: 1200,
        dpi: 1,
        fontSize: 20,
    },
    normalLandscapeUp: {
        type: 'breakpoint',
        query: '(max-width: 1023px)',
        min: 901,
        max: 1023,
        dpi: 1,
        fontSize: 18,
    },
    normalLandscapeDown: {
        type: 'breakpoint',
        query: '(min-width: 1023px)',
        min: 901,
        max: 1023,
        dpi: 1,
        fontSize: 18,
    },
    tweak900up: {
        type: 'tweakpoint',
        query: '(max-width: 900px)',
        min: 801,
        max: 900,
        dpi: 1,
        fontSize: 18,
    },
    normalPortraitUp: {
        query: '(max-width: 800px)',
        min: 701,
        max: 800,
        dpi: 1,
        fontSize: 18,
        type: 'breakpoint',
    },
    tweak700up: {
        type: 'tweakpoint',
        query: '(max-width: 700px)',
        min: 601,
        max: 700,
        dpi: 1,
        fontSize: 16,
    },
    tweak600up: {
        type: 'tweakpoint',
        query: '(max-width: 600px)',
        min: 501,
        max: 600,
        dpi: 1,
        fontSize: 16,
    },
    tweak500up: {
        type: 'tweakpoint',
        query: '(max-width: 500px)',
        min: 401,
        max: 500,
        dpi: 1,
        fontSize: 16,
    },
    smallPortraitUp: {
        type: 'breakpoint',
        query: '(min-width: 400px)',
        min: 400,
        max: 0,
        dpi: 1,
        fontSize: 16,
    },
    smallPortraitOnly: {
        type: 'breakpoint',
        query: '(max-width: 400px)',
        min: 0,
        max: 400,
        dpi: 1,
        fontSize: 16,
    },
};
export default breakpoints;

export const breakpointsMax = () => {
    const result = [];
    Object.keys(breakpoints).reverse().forEach(key => {
        const breakpoint = breakpoints[key];
        if (breakpoint.max && breakpoint.type === 'breakpoint' && breakpoint.max > 0) {
            result.push(breakpoint.max);
        }
    });
    return result;
};

export const breakpointsMaxKey = Object.keys(breakpoints).reverse().filter(key =>
    breakpoints[key].max && breakpoints[key].type === 'breakpoint' && breakpoints[key].max !== 0);

export const breakpointsFontsize = Object.keys(breakpoints).reverse().map(key => (breakpoints[key].fontSize));

export const breakpointsQuery = Object.keys(breakpoints).reverse().map(key => (breakpoints[key].query));

const buildMedia = () => {
    const result = {};
    Object.keys(breakpoints).reverse().forEach(key => {
        const breakpoint = breakpoints[key];
        if (breakpoint.query) {
            const query = `@media ${breakpoint.query}`;
            result[key] = (...args) => css`
            ${query} {
                ${css(...args)}
            }
        `;
        }
    });
    return result;
};
export const media = buildMedia();



// WEBPACK FOOTER //
// ./src/components/styles/breakpoints.js